interface ThemeConfig {
  app: {
    name: string;
  };
  layout: {
    darkMode: boolean;
    menu: {
      isCollapsed: boolean;
      isHidden: boolean;
    };
    mobileMenu: boolean;
  };
}

const themeConfig: ThemeConfig = {
  app: {
    name: "Dashcode React",
  },
  // layout
  layout: {
    darkMode: false,
    menu: {
      isCollapsed: false,
      isHidden: false,
    },
    mobileMenu: false,
  },
};

export default themeConfig;
